/**
 * Единые подписи enum в UI. Сырые значения с бэкенда в интерfacе не показываем — только «—», если ключа нет.
 */

const EXECUTOR_TYPE_LABELS: Record<string, string> = {
  COMPANY: 'Наш транспорт',
  OUR_COMPANY: 'Наш транспорт',
  OWN_TRANSPORT: 'Наш транспорт',
  CONTRACTOR: 'Перевозчик',
  PARTNER: 'Партнёр'
};

/** Тип исполнителя маршрута (route.executor и т.п.) */
export function executorTypeLabel(value: string | null | undefined): string {
  const k = String(value ?? '')
    .trim()
    .toUpperCase();
  if (!k) return '—';
  return EXECUTOR_TYPE_LABELS[k] ?? '—';
}

const FINANCE_DIRECTION_LABELS: Record<string, string> = {
  INCOME: 'Доход',
  EXPENSE: 'Расход',
  RECEIVABLE: 'Доход',
  PAYABLE: 'Расход'
};

/** Направление обязательства / счёта (obligation.direction, invoice.direction) */
export function financeDirectionLabel(value: string | null | undefined): string {
  const k = String(value ?? '')
    .trim()
    .toUpperCase();
  if (!k) return '—';
  return FINANCE_DIRECTION_LABELS[k] ?? '—';
}

/** Полный словарь типов документов для фильтров и т.п. (значение → подпись) */
export const DOCUMENT_TYPE_UI_LABELS: Record<string, string> = {
  LOADING_TN: 'Документы погрузки',
  LOADING_PHOTO: 'Фото с погрузки',
  INVOICE: 'Счёт клиенту',
  CARRIER_CONTRACT_REQUEST: 'Договор-заявка перевозчика',
  CARRIER_INVOICE: 'Счёт перевозчика',
  LOADING_INVOICE: 'Счёт с погрузки',
  SIGNED_TN: 'ТН подписанная',
  ORIGINAL_TN: 'Оригиналы ТН',
  TN_ORIGINAL: 'Оригиналы ТН',
  UPD_ACT: 'УПД/Акт',
  UNLOADING_DOC: 'Документы выгрузки',
  UNLOADING_PHOTO: 'Фото с выгрузки',
  LOADING_DOCUMENTS: 'Документы погрузки',
  UNLOADING_DOCUMENTS: 'Документы выгрузки',
  LOADING_PHOTOS: 'Фото с погрузки',
  UNLOADING_PHOTOS: 'Фото с выгрузки',
  CARRIER_UPD: 'УПД перевозчика',
  CARRIER_TN_TTH_ORIGINALS: 'Оригиналы ТН/ТТН',
  AIR_WAYBILL: 'AWB / авиадокументы',
  RAIL_WAYBILL: 'ЖД накладная',
  AWB: 'AWB / авиадокументы',
  PRIMARY_DOCS: 'Первичные документы клиента',
  primary_docs: 'Первичные документы клиента',
  POWER_OF_ATTORNEY: 'Доверенность',
  CARGO_DOCS: 'Документы по грузу',
  OTHER: 'Другое',
};

/** Тип документа (document.documentType) */
export function documentTypeLabel(value: string | null | undefined): string {
  const k = String(value ?? '')
    .trim()
    .toUpperCase();
  if (!k) return '—';
  return DOCUMENT_TYPE_UI_LABELS[k] ?? '—';
}

/** @deprecated Import from features/finance/constants/routeExpenseTypes — re-export for compatibility */
export { routeExpenseTypeLabel } from '../features/finance/constants/routeExpenseTypes';

/** Код триггера обязательства (triggerCode) */
const OBLIGATION_TRIGGER_CODE_LABELS: Record<string, string> = {
  ON_LOADING: 'по факту погрузки',
  BEFORE_LOADING: 'перед погрузкой',
  ON_UNLOADING: 'по факту выгрузки',
  ORIGINALS_RECEIVED: 'после получения оригиналов',
  SCANS_SENT: 'после получения сканов',
  INVOICE_RECEIVED: 'после получения счёта'
};

export function obligationTriggerCodeLabel(value: string | null | undefined): string {
  const k = String(value ?? '')
    .trim()
    .toUpperCase();
  if (!k) return '—';
  return OBLIGATION_TRIGGER_CODE_LABELS[k] ?? '—';
}
